import type { Session } from '@supabase/supabase-js';
import { type ReactNode, createContext, useContext, useEffect, useState } from 'react';
import { ADMIN_ALLOWED_EMAIL, supabase } from './supabase';

interface AuthCtx {
  session: Session | null;
  loading: boolean;
  authorized: boolean;
}

const Ctx = createContext<AuthCtx>({ session: null, loading: true, authorized: false });

export function AuthProvider({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session);
      setLoading(false);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => setSession(s));
    return () => sub.subscription.unsubscribe();
  }, []);

  const authorized =
    !!session && session.user.email?.toLowerCase() === ADMIN_ALLOWED_EMAIL.toLowerCase();
  return <Ctx.Provider value={{ session, loading, authorized }}>{children}</Ctx.Provider>;
}

export function useAuth() {
  return useContext(Ctx);
}
